import React from 'react';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
/**DATE FILED CONSTANTS */
export var UNIQUE_KEY_DATE_FILED = 'date-filed-key';
export var LABEL_TEXT_DATE_FILED = 'Date filed';
export var PATENT_DATA_FILED_TEST_ID = 'date_filed_input_test';

/**DATE ISSUED CONSTANTS */
export var UNIQUE_KEY_DATE_ISSUED = 'date-issued-key';
export var LABEL_TEXT_DATE_ISSUES = 'Date issued';
export var PATENT_DATA_ISSUED_TEST_ID = 'date_issued_input_test';
var PREFIX_FOR_TEST_IDS = 'patent-form';
export var PatentContributorOptions;
(function (PatentContributorOptions) {
  PatentContributorOptions["INVENTOR"] = "Inventor";
})(PatentContributorOptions || (PatentContributorOptions = {}));
export var PatentContributorFunctions = [{
  uuid: FunctionTypes.AUTHOR,
  value: FunctionTypes.AUTHOR,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, PatentContributorOptions.INVENTOR)
}];

/** test ids for form and sections inside it */
export var TestIds = {
  PATENT_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  PATENT_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-patent-pub-info-sec-test-id")
};